import { fetcher } from '@/libs/fetcher'
import { ISettingsResponse } from '@/services/settings/settings.types'

const commonURL = 'api/v1/settings'

export const getSettings = (params?: Record<string, string>, headers?: Record<string, string>) => {
  return fetcher<ISettingsResponse>(`/${commonURL}`, params, { headers, method: 'GET' })
}
